import { Checkbox, Icon, Spinner } from '@chakra-ui/react';
import { ImportStatusType } from 'app/components/Import';
import { getMessageByStatus } from 'app/components/Import/utils';
import { ReactComponent as InfoIcon } from 'resources/images/info.svg';

interface ImportStatusProps {
  status?: ImportStatusType;
}

export const ImportStatus = ({ status }: ImportStatusProps) => {
  if (!status) {
    return null;
  }

  if (status === 'success') {
    return <Checkbox ml={2} isChecked={status === 'success'} />;
  }

  if (status === 'in_progress') {
    return <Spinner />;
  }

  const errorMsg =
    status === 'inconsistent'
      ? "Some songs didn't match songs meta data uploaded above, try again or upload meta data first"
      : getMessageByStatus(status);

  return (
    <Icon title={errorMsg} h={6} w={6} as={InfoIcon} color="textSubdued" />
  );
};
